export default __webpack_public_path__ + "static/media/burberry.eee2173a.png";